import { gql } from "@apollo/client";
import { ORDER_FRAGMENT } from "order/fragments/order";

import { TICKET_WITH_RELATIONS_FRAGMENT } from "./fragments/ticketWithRelations";

export const TICKET_LIST_QUERY = gql`
  ${TICKET_WITH_RELATIONS_FRAGMENT}
  ${ORDER_FRAGMENT}
  query TicketList(
    $take: Int
    $skip: Int
    $filters: TicketFilterInput
    $orderBy: [TicketOrderByInput!]
    $ticketPoolInclude: Boolean = false
    $eventInclude: Boolean = false
    $fileInclude: Boolean = false
    $orderInclude: Boolean = false
  ) {
    tickets(take: $take, skip: $skip, filters: $filters, orderBy: $orderBy) {
      count
      nodes {
        ...TicketWithRelations
      }
    }
  }
`;

export const TICKET_READ_QUERY = gql`
  ${TICKET_WITH_RELATIONS_FRAGMENT}
  ${ORDER_FRAGMENT}
  query TicketRead(
    $id: Int!
    $ticketPoolInclude: Boolean = false
    $eventInclude: Boolean = false
    $fileInclude: Boolean = false
    $orderInclude: Boolean = false
  ) {
    ticket(id: $id) {
      ...TicketWithRelations
    }
  }
`;
